import React from "react";
import Lexical from "lexical";
import {useTranslation} from "react-i18next";
import {useResizeDetector} from "../../../hooks/useResizeDetector";
import {CellContent} from "../../../models/CellContent";
import {LexicalEditor} from "./LexicalEditor";

type PerceptionEditorProps = {
    isEdit: boolean;
    content: CellContent;
    onBlur: (content: CellContent) => void;
    onChangeEditorHeight: (height: number) => void;
    onChangeContent: (content: CellContent) => void;
}
export const PerceptionEditor = (props: PerceptionEditorProps) => {
    const {t} = useTranslation();

    const [perception_content, makeContent] = props.content.usePerceptionContent();
    const around_editor_ref = React.useRef<HTMLDivElement>(null);

    useResizeDetector(around_editor_ref, (_, height) => {
        props.onChangeEditorHeight(height);
    });

    const handleChange = (editor_state: Lexical.EditorState) => {
        const jc_editor_state = perception_content.EditorState.withLexicalEditorState(editor_state);
        const content = makeContent(perception_content.withEditorState(jc_editor_state));
        props.onChangeContent(content);
    };

    const handleBlur = (editor_state: Lexical.EditorState) => {
        props.onBlur(makeContent(
            perception_content.withEditorState(perception_content.EditorState.withLexicalEditorState(editor_state))
        ));
    }

    return (
        <div className={"cellEditor"}
             ref={around_editor_ref}
             onKeyDown={(e) => e.stopPropagation()} // ContentCell の onKeyDown を抑制
        >
            <LexicalEditor
                editorState={perception_content.EditorState.getInternalEditorState()}
                isEdit={props.isEdit}
                onChange={handleChange}
                onBlur={handleBlur}
                showToolbar={props.isEdit}
            />
            {perception_content.IsEmpty && !props.isEdit && <span className="empty-description">{t("説明を追加")}</span>}
        </div>
    );
}
